import React from 'react'
import StyleSheet from 'styles'

const styles = StyleSheet({
  dividerWrap: {
    display: 'flex',
    flex: '0 auto',
    marginTop: 10,
    marginBottom: 6
  },
  dividerWord: {
    textAlign: 'center',
    color: 'white',
    flex: '0 auto',
    width: '100%',
    fontSize: 15,
    fontWeight: 'bold',
    margin: '20px 0 5px 0'
  }
})

export const WordDivider = props =>
  <div className={styles.dividerWrap}>
    <div className={styles.dividerWord}>{props.word}</div>
  </div>
